import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import { type VirtualElement } from "@floating-ui/dom";

import AtlasTooltip from "@/components/display/atlas-tooltip/atlas-tooltip";

import styles from "./atlas-chart-tooltip.scss";

import "@/components/display/atlas-private-content/atlas-private-content";

/**
 * @dependency atlas-private-content
 *
 * @slot - O slot padrão serve para adicionar conteúdos ao tooltip
 * 
 * @tag atlas-chart-tooltip
 */
@customElement("atlas-chart-tooltip")
export default class AtlasChartTooltip extends AtlasTooltip {
    static styles = styles;

    /** Rótulo do eixo X que irá ser apresentado no tooltip */
    @property({ type: String, attribute: "x-axis-label" }) xAxisLabel: string = "";

    constructor() {
        super("hover", "top");
    }

    /**
     * Define a posição do tooltip em relação ao elemento âncora.
     * @param anchorElement Elemento âncora que irá ser utilizado para posicionar o tooltip
     */
    public setTooltipPosition(anchorElement: VirtualElement) {
        this._floatingUiController.anchorElement = anchorElement;
        this._floatingUiController.floatingElement = this.getFloatingElement();
        this._floatingUiController.updatePosition();
    }

    protected async onOpenOverlay() {
        await this.updateComplete;

        this.removeAttribute("tabindex");

        this.tooltip.hidden = false;
    }

    protected async onCloseOverlay() {
        await this.updateComplete;

        this.setAttribute("tabindex", "-1");

        this.tooltip.hidden = true;
    }

    /** @internal */
    public render() {
        const tooltipClass = {
            "tooltip": true,
            "tooltip-auto": true,
            "fade": true,
            "show": this.open
        };

        return html`
            <div
                class=${classMap(tooltipClass)}
                role="tooltip"
                aria-hidden=${this.open ? "false" : "true"}
                aria-labelledby="tooltip-slot"
            >
                <div class="tooltip-arrow"></div>
                <div class="tooltip-inner">
                    <span class="x-axis-label">${this.xAxisLabel}</span>
                    <slot id="tooltip-slot"></slot>
                </div>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "atlas-chart-tooltip": AtlasChartTooltip;
    }
}